import {ConditionalAmountList} from "#pricing/nodes/conditional-amount-list"
import type {ConditionalAmountNode} from "#pricing/nodes/conditional-amount-node"
import {PricingNode, registerPricingGraphNode} from "#pricing/pricing-node"
import type {PricingContext} from "#pricing/pricing-context"
import type {Evaluator, GraphNodeDefinition} from "@cm/graph-v3"
import {graphNode} from "@cm/graph-v3"
import {z} from "zod/v4-mini"

export type ConditionalAmountGroupParameters = {
    description: string
    defaultAmount: number
    amountNodes: ConditionalAmountList
}

const conditionalAmountGroupNodeDefinition = {
    nodeClass: "ConditionalAmountGroupNode",
    validation: {
        parameters: z.object({
            description: z.string(),
            defaultAmount: z.number(),
            amountNodes: graphNode(ConditionalAmountList),
        }),
        returns: z.number(),
    },
} satisfies GraphNodeDefinition<number, ConditionalAmountGroupParameters>

@registerPricingGraphNode
export class ConditionalAmountGroupNode extends PricingNode<number, ConditionalAmountGroupParameters> {
    public override get definition() {
        return conditionalAmountGroupNodeDefinition
    }

    override run = async (evaluator: Evaluator<PricingContext>) => {
        const amountNodes = await evaluator.get(this.parameters.amountNodes)
        const nonZeroValues = amountNodes.filter((value) => value !== 0)
        if (nonZeroValues.length > 1) throw new Error("More than one non-zero value found")
        return nonZeroValues.length === 1 ? nonZeroValues[0] : this.parameters.defaultAmount
    }

    getAmountNodes(): ConditionalAmountNode[] {
        return this.parameters.amountNodes.parameters.list
    }
}
